import { useState, forwardRef, useEffect, useCallback, useRef } from "react";
import { resolutionUpdate } from "../../API/NewCreateCollectionAPI";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Slide,
  styled,
  Switch,
  Typography,
  IconButton,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import React, { useMemo } from "react";
import { CustomInput, PageTitle, PillRadio } from "../../components-new/common";
import TabComponent from "../../components-new/common/TabComponent";
import { BrowserOptions } from "../../components-new/utils/constants";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../../Config/Config";
import { getresolutionAPI } from "../../API/adminAPI";
import stringify from "json-stringify-pretty-compact";
import {
  useExecuteTestSuitesMutation,
  useGetEnvQuery,
  useLicenceKeyQuery,
  useUpdateHeadless,
  useUpdateParallel,
  useUpdateImageCompare,
  useUpdateResultEmail,
  useUpdateScreenShot,
  useUpdateStopAfterFail,
  useUpdateSuiteBrowser,
  useUpdateSuiteEmail,
  useUpdateSuiteUrl,
  useUpdateSync,
  useUpdateBM,
  useUpdateReRunParallel,
  useUpdateTestSuiteThreadCount,
  useUpdateRunOnAllDevices,
  useSaveVariables,
  useUpdateTestSuiteIsVideoEnabled,
  useUpdateEmailOnSuiteFailureOnly,
} from "../../useQuery";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateSuiteField } from "../../Redux/TestSuite/TestSuite";
import debounce from "lodash/debounce";
import useUpdateRerun from "../../useQuery/useUpdateRerun";
import Scheduler from "./Scheduler";
import IntegrationTab from "./IntegrationTab";
import { useNotification } from "../../hooks";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useQueryClient } from "@tanstack/react-query";

dayjs.extend(advancedFormat);

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "auto",
    padding: theme.spacing(2),
  },
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "13px",
  fontWeight: 500,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  padding: "15px 28px",
  borderRadius: "8px",
  textTransform: "capitalize",
  textAlign: "center",
  fontSize: "17px",
  fontWeight: 600,
  lineHeight: "20px",
  cursor: "pointer",
}));

const VariableRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

function stringToBoolean(value) {
  return value === "true";
}

export default function TestSuiteSettings({ open, setOpenSuiteSettings, suite }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notify = useNotification();
  const queryClient = useQueryClient();
  const { data } = useLicenceKeyQuery();
  const { refetchWithParams } = useUpdateSuiteBrowser();
  const { refetchWithParams: updateStopAfterFail } = useUpdateStopAfterFail();
  const { refetchWithParams: updateRerun } = useUpdateRerun();
  const { refetchWithParams: updateParallel } = useUpdateParallel();
  const { refetchWithParams: updateReRunParallel } = useUpdateReRunParallel();
  const { refetchWithParams: updateThreadCount } = useUpdateTestSuiteThreadCount();
  const { refetchWithParams: updateSync } = useUpdateSync();
  const { refetchWithParams: updateBM } = useUpdateBM();
  const { refetchWithParams: udpateHeadless } = useUpdateHeadless();
  const { refetchWithParams: updateScreenShot } = useUpdateScreenShot();
  const { refetchWithParams: updateResultEmail } = useUpdateResultEmail();
  const { refetchWithParams: updateRunOnAllDevices } = useUpdateRunOnAllDevices();
  const { refetchWithParams: updateTestSuiteIsVideoEnabled } = useUpdateTestSuiteIsVideoEnabled();
  const updateEmailOnSuiteFailureOnly = useUpdateEmailOnSuiteFailureOnly();
  const { data: envData, refetch: fetchEnv } = useGetEnvQuery(suite.productid);
  const integrationRef = useRef(null);
  const [resolutionOptions, setResolutionOptions] = useState([]);

  const [selectedResolution, setSelectedResolution] = useState("default");

  useEffect(() => {
    if (suite?.productid && open) {
      getresolutionAPI(suite.productid).then((res) => {
        if (res?.data?.web) {
          setResolutionOptions(res.data.web);
        }
      });
    }
  }, [suite?.productid, open]);
  const [proxyUrl, setProxyUrl] = useState("");
  const [iterations, setIterations] = useState("");
  const [threadCountInput, setThreadCountInput] = useState("");
  const [threadCountError, setThreadCountError] = useState(false);

  const [variables, setVariables] = useState([{ key: "", value: "" }]);
  const [jsonPreview, setJsonPreview] = useState("{}");
  const [jsonError, setJsonError] = useState(false);
  const [jsonErrorMessage, setJsonErrorMessage] = useState("");
  const [imageCompare, setImageCompare] = useState(false);

  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const temp = JSON.parse(userDetails);

  const { mutate: handleExecuteTestSuite, isSuccess: isExecuteTestSuiteSuccess } =
    useExecuteTestSuitesMutation();
  const { mutate: updateEmail } = useUpdateSuiteEmail();
  const { mutate: udpateSuiteUrl } = useUpdateSuiteUrl();
  const { mutate: saveVariables, isSuccess: isSaveVariablesSuccess } = useSaveVariables({
    onSuccess: () => {
      notify("Variables saved successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["testSuiteNew"],
        exact: false,
      });
    },
    onError: (error) => {
      notify(error.message || "Failed to save variables", "error");
    },
  });

  useEffect(() => {
    if (suite && suite.variables) {
      const variablesArray = Object.entries(suite.variables).map(([key, value]) => ({
        key,
        value: typeof value === "object" ? JSON.stringify(value) : String(value),
      }));

      if (variablesArray.length > 0) {
        setVariables(variablesArray);

        try {
          setJsonPreview(stringify(suite.variables));
        } catch (error) {
          setJsonPreview("{}");
        }
      }
    }
  }, [suite]);

  useEffect(() => {
    if (!open) return;
    fetchEnv();
    queryClient.invalidateQueries({ queryKey: ["testSuiteNew"], exact: false });
    queryClient.invalidateQueries({ queryKey: ["GetTestSuitesTest"], exact: false });
  }, [open]);

  useEffect(() => {
    if (suite && suite.threadcount) {
      setThreadCountInput(suite.threadcount);
    }
  }, [suite]);

  useEffect(() => {
    if (suite?.height > 1 && suite?.width > 1) {
      setSelectedResolution(`${suite.width}x${suite.height}`);
    } else {
      setSelectedResolution("default");
    }
  }, [suite?.height, suite?.width]);

  useEffect(() => {
    if (isExecuteTestSuiteSuccess) {
      navigate("/new/suite-reports", {
        state: {
          isExecuteClick: true,
          selectedSuit: suite.idtest_suite,
          product: suite.productid,
          fetchTestSuite: true,
          initialSuiteExecution: true,
        },
      });
    }
  }, [isExecuteTestSuiteSuccess, navigate]);

  useEffect(() => {
    try {
      const variablesObj = {};
      variables.forEach(({ key, value }) => {
        if (key.trim() !== "") {
          variablesObj[key] = value;
        }
      });
      setJsonPreview(stringify(variablesObj));
    } catch (error) {
      setJsonPreview("Error formatting JSON");
    }
  }, [variables]);

  const selectedBrowsers = useMemo(() => {
    if (!suite?.browser) return null;

    if (Array.isArray(suite.browser)) return suite.browser;

    if (typeof suite.browser === "string") {
      return suite.browser.split(",").map((b) => b.trim());
    }

    return null;
  }, [suite?.browser]);

  const debouncedUpdateEmail = useCallback(
    debounce((email) => updateEmail({ data: { email: email }, id: suite.idtest_suite }), 800),
    [suite.idtest_suite, updateEmail],
  );

  const handleEmailOnSuiteFailureOnlyToggle = () => {
    const newValue = !suite.emailOnSuiteFailureOnly;
    updateEmailOnSuiteFailureOnly.mutate(
      { id: suite.idtest_suite, value: newValue },
      {
        onSuccess: () => {
          dispatch(
            updateSuiteField({
              field: "emailOnSuiteFailureOnly",
              value: newValue,
            }),
          );
        },
      },
    );
  };

  const handleThreadCountUpdate = () => {
    const threadCount = parseInt(threadCountInput);
    if (isNaN(threadCount) || threadCount <= 0) {
      notify("Please Enter a Valid Positive Number", "error");
      return;
    }

    if (threadCount > parseInt(suite.companyThreadCount)) {
      notify(`Thread count must be less than or equal to ${suite.companyThreadCount} `, "error");
      return;
    }
    setThreadCountError(false);
    updateThreadCount(suite.idtest_suite, threadCount);
    dispatch(updateSuiteField({ field: "threadcount", value: threadCount.toString() }));
    setThreadCountInput("");
    notify("Thread count updated successfully", "success");
  };

  const addVariableRow = () => {
    setVariables([...variables, { key: "", value: "" }]);
  };

  const removeVariableRow = (index) => {
    if (variables.length === 1) {
      setVariables([{ key: "", value: "" }]);
    } else {
      const updatedVariables = [...variables];
      updatedVariables.splice(index, 1);
      setVariables(updatedVariables);
    }
  };

  const handleVariableChange = (index, field, value) => {
    const updatedVariables = [...variables];
    updatedVariables[index][field] = value;
    setVariables(updatedVariables);
  };

  const handleJsonPreviewChange = (e) => {
    const newJson = e.target.value;
    setJsonPreview(newJson);
    try {
      const parsedJson = JSON.parse(newJson);
      const newVariables = Object.entries(parsedJson).map(([key, value]) => ({
        key,
        value: typeof value === "object" ? JSON.stringify(value) : String(value),
      }));

      if (newVariables.length === 0) {
        setVariables([{ key: "", value: "" }]);
      } else {
        setVariables(newVariables);
      }

      setJsonError(false);
      setJsonErrorMessage("");
    } catch (error) {
      setJsonError(true);
      setJsonErrorMessage("Invalid JSON format");
    }
  };

  const handleSaveVariables = () => {
    const variablesObj = {};
    variables.forEach(({ key, value }) => {
      if (key.trim() !== "") {
        try {
          variablesObj[key] =
            value.trim().startsWith("{") || value.trim().startsWith("[")
              ? JSON.parse(value)
              : value;
        } catch {
          variablesObj[key] = value;
        }
      }
    });

    saveVariables({
      tsid: suite.idtest_suite,
      data: variablesObj,
    });
  };

  const handleRun = () => {
    const threadCount = Number(suite?.threadcount ?? 0);
    if (threadCount <= 0) {
      notify("Suite thread count must be greater than 0 before running.", "warning");
      return;
    }

    const intData = integrationRef.current?.getIntegrationData() || {};
    const {
      selectedIntegration,
      intType,
      issueobj,
      serviceNowData,
      workItemIds,
      logLevelToggle,
      resultTypeToggle,
    } = intData;

    if (
      selectedIntegration !== "ServiceNow" &&
      selectedIntegration !== "Service Now" &&
      issueobj?.logId === "new" &&
      (!issueobj?.projectkey || issueobj?.projectkey === "")
    ) {
      notify("Project key is Null!", "warning");
      return;
    }
    const [resWidth, resHeight] =
      selectedResolution && selectedResolution !== "default"
        ? selectedResolution.split("x").map(Number)
        : [null, null];
    const resolution = { width: resWidth || "", height: resHeight || "" };
    const suiteLength = suite.list.length;
    // if (suiteLength == 0) {
    //   notify("Suite is empty!", "warning");
    //   return;
    // }

    const toggleLogLevel = logLevelToggle ? "CaseLevel" : "SuiteLevel";
    const toggleLogType = resultTypeToggle ? "Both" : "OnlyFail";

    const payload = {
      prodid: suite.productid,
      suitid: suite.idtest_suite,
      envname: suite.envurl || "",
      envUrl: "",
      browser: suite.browser,
      stop: suite.stopafterfailure,
      rerun: suite.rerunfailedtests,
      runparallel: suite.supports_parallel_execution,
      rerunparallel: suite.rerun_in_parallel,
      ssfail: suite.ssonerror,
      indEmail: suite.indEmail,
      emailOnSuiteFailureOnly: suite.emailOnSuiteFailureOnly,
      inputemail: suite.resultsemail,
      height: resolution.height || "",
      width: resolution.width || "",
      iterations: iterations || "1",
      proxy: proxyUrl,
      intType: intType || null,
      criteria: "",
      tsrid: "",
      execLogType: toggleLogType,
      execLogLevel: toggleLogLevel,
      issueDescription: "",
    };

    if (selectedIntegration === "ServiceNow" || selectedIntegration === "Service Now") {
      payload.issueLogType = serviceNowData?.category || "";
      payload.issueLogLevel = serviceNowData?.subcategory || "";
      payload.issueMessage = serviceNowData?.issueTitle || "";
      payload.issueDescription = serviceNowData?.message || "";
    } else if (
      selectedIntegration === "Jira" ||
      selectedIntegration === "Azure Dev Ops" ||
      selectedIntegration === "AzureDevOps"
    ) {
      payload.issueLogType = issueobj?.logType || "";
      payload.logId = issueobj?.logId || "";
      payload.projectKey = issueobj?.projectkey || "";
      payload.issueDescription = issueobj?.message || "";
    } else if (
      selectedIntegration === "Slack" ||
      selectedIntegration === "MS Teams Channel" ||
      selectedIntegration === "MSTeamsChannel"
    ) {
      payload.issueLogType =
        workItemIds?.[selectedIntegration] ||
        workItemIds?.["Slack"] ||
        workItemIds?.["MS Teams Channel"] ||
        "";
    }

    handleExecuteTestSuite(payload);
  };

  const isSaveEnabled =
    variables.length > 0 &&
    variables.every((v) => v.key && v.key.trim() !== "" && v.value && v.value.trim() !== "");

  const tabs = [
    {
      icon: <></>,
      label: "Run Parameters",
      content: (
        <>
          <Box p={2} display={"flex"}>
            <Box flex={1}>
              <Box>
                <StyledLabel>
                  {suite?.suite_Type === "mobile" ? "App Version" : "Environment"}
                </StyledLabel>
                <Box>
                  <PillRadio
                    key="As recorded"
                    value=""
                    label="As Recorded"
                    checked={!suite.envurl}
                    onChange={() => {
                      dispatch(updateSuiteField({ field: "envurl", value: "" }));
                      udpateSuiteUrl({
                        data: { url: "" },
                        id: suite.idtest_suite,
                      });
                    }}
                  />
                  {envData?.map((option) => (
                    <PillRadio
                      key={option.idenvdetails}
                      value={option.idenvdetails}
                      label={option.envname}
                      checked={suite.envurl === option.idenvdetails}
                      onChange={(event) => {
                        dispatch(updateSuiteField({ field: "envurl", value: event.target.value }));
                        udpateSuiteUrl({
                          data: { url: event.target.value },
                          id: suite.idtest_suite,
                        });
                      }}
                    />
                  ))}
                </Box>
              </Box>
              {suite?.suite_Type !== "mobile" && (
                <Box pt={2}>
                  <StyledLabel>Screen Resolution</StyledLabel>
                  <Box>
                    <>
                      <PillRadio
                        key="default"
                        value="default"
                        label="Default"
                        checked={selectedResolution === "default"}
                        onChange={() => {
                          setSelectedResolution("default");
                          resolutionUpdate(suite.idtest_suite, 0, 0);
                          queryClient.invalidateQueries({ queryKey: ["GetTestSuitesTest"] });
                        }}
                      />
                      {resolutionOptions.length > 0 ? (
                        resolutionOptions.map((option) => (
                          <PillRadio
                            key={option.id}
                            value={`${option.width}x${option.height}`}
                            label={`${option.width}x${option.height}`}
                            checked={selectedResolution === `${option.width}x${option.height}`}
                            onChange={(event) => {
                              setSelectedResolution(event.target.value);
                              resolutionUpdate(suite.idtest_suite, option.height, option.width);
                              queryClient.invalidateQueries({ queryKey: ["GetTestSuitesTest"] });
                            }}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                          No resolutions available. Please{" "}
                          <Button
                            onClick={() =>
                              navigate("/new/admin", { state: { tab: 1, subTab: "resolution" } })
                            }
                            sx={{
                              color: "#1976d2",
                              textTransform: "none",
                              fontWeight: 500,
                              padding: 0,
                              minWidth: "auto",
                              "&:hover": {
                                backgroundColor: "transparent",
                                textDecoration: "underline",
                              },
                            }}
                          >
                            add resolutions
                          </Button>{" "}
                          in Admin settings for better experience.
                        </Typography>
                      )}
                    </>
                  </Box>
                </Box>
              )}

              {suite?.suite_Type !== "mobile" && (
                <Box pt={2}>
                  <StyledLabel>Browser</StyledLabel>

                  <Box>
                    {BrowserOptions.map((option) => {
                      const isDefault = selectedBrowsers === null;

                      const isAll =
                        Array.isArray(selectedBrowsers) && selectedBrowsers.includes("ALL");

                      let checked = false;

                      if (option.value === "DEFAULT") {
                        checked = isDefault;
                      } else if (option.value === "ALL") {
                        checked = isAll;
                      } else {
                        checked =
                          Array.isArray(selectedBrowsers) &&
                          selectedBrowsers.includes(option.value);
                      }

                      return (
                        <PillRadio
                          key={option.value}
                          value={option.value}
                          label={option.label}
                          checked={checked}
                          onChange={() => {
                            let updatedBrowsers = selectedBrowsers;

                            if (option.value === "DEFAULT") {
                              updatedBrowsers = null;
                            } else if (option.value === "ALL") {
                              updatedBrowsers = ["ALL"];
                            } else {
                              if (!Array.isArray(selectedBrowsers) || isAll) {
                                updatedBrowsers = [option.value];
                              } else if (selectedBrowsers.includes(option.value)) {
                                updatedBrowsers = selectedBrowsers.filter(
                                  (b) => b !== option.value,
                                );
                              } else {
                                updatedBrowsers = [...selectedBrowsers, option.value];
                              }
                            }

                            const valueToStore =
                              updatedBrowsers === null ? null : updatedBrowsers.join(",");

                            dispatch(
                              updateSuiteField({
                                field: "browser",
                                value: valueToStore,
                              }),
                            );

                            refetchWithParams(suite.idtest_suite, valueToStore);
                          }}
                        />
                      );
                    })}
                  </Box>
                </Box>
              )}
              <Box pt={2}>
                <StyledLabel>Thread Configuration</StyledLabel>
                <Box
                  sx={{
                    background: "#f8f9fa",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    marginTop: 1,
                    marginBottom: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#555" }}>
                      Total Thread Count:{" "}
                      <span style={{ color: "#ff5336" }}>{suite.companyThreadCount}</span>
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#555" }}>
                      Suite Thread Count:{" "}
                      <span style={{ color: "#ff5336" }}>{suite.threadcount}</span>
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-end", gap: 2, width: "100%" }}>
                  <CustomInput
                    labelinput="Update Suite Thread Count"
                    placeholder={"Enter new thread count"}
                    value={threadCountInput}
                    onChange={(e) => setThreadCountInput(e.target.value)}
                    onFocus={() => {
                      if (!threadCountInput) {
                        setThreadCountInput(suite.threadcount);
                      }
                    }}
                    error={Boolean(threadCountError)}
                    helperText={threadCountError}
                    type="number"
                    inputProps={{ min: 1, max: suite.companyThreadCount }}
                    sx={{ flex: 1, minWidth: "150px" }}
                  />
                  <StyledButton
                    variant="text"
                    color="warning"
                    sx={{
                      backgroundColor: "#ff5336",
                      color: "#ffffff",
                      height: "45px",
                      boxShadow: "0px 8px 15px 0px rgba(255, 83, 54, 0.2)",
                    }}
                    onClick={handleThreadCountUpdate}
                  >
                    Save
                  </StyledButton>
                </Box>
              </Box>
            </Box>
            <Box flex={1} p={2}>
              <FormGroup sx={{ display: "flex", rowGap: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.stopafterfailure === "true"}
                      onChange={() => {
                        const newValue = !stringToBoolean(suite.stopafterfailure);

                        dispatch(
                          updateSuiteField({
                            field: "stopafterfailure",
                            value: newValue.toString(),
                          }),
                        );

                        updateStopAfterFail(suite.idtest_suite, newValue);
                      }}
                    />
                  }
                  label="Terminate test even if a single test case fails"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.rerunfailedtests === "true"}
                      onChange={() => {
                        const newValue = !stringToBoolean(suite.rerunfailedtests);

                        dispatch(
                          updateSuiteField({
                            field: "rerunfailedtests",
                            value: newValue.toString(),
                          }),
                        );

                        updateRerun(suite.idtest_suite, newValue);
                      }}
                    />
                  }
                  label="Re-run failed test cases"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.supports_parallel_execution === "true"}
                      onChange={() => {
                        const newValue = !stringToBoolean(suite.supports_parallel_execution);

                        dispatch(
                          updateSuiteField({
                            field: "supports_parallel_execution",
                            value: newValue.toString(),
                          }),
                        );

                        updateParallel(suite.idtest_suite, newValue);
                      }}
                    />
                  }
                  label="Runs Tests in Parallel"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.rerun_in_parallel === "true"}
                      onChange={() => {
                        const newValue = !stringToBoolean(suite.rerun_in_parallel);

                        dispatch(
                          updateSuiteField({
                            field: "rerun_in_parallel",
                            value: newValue.toString(),
                          }),
                        );

                        updateReRunParallel(suite.idtest_suite, newValue);
                      }}
                    />
                  }
                  label="Re Run Tests In Parallel"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.synchedscenarios ? true : false}
                      onChange={() => {
                        dispatch(
                          updateSuiteField({
                            field: "synchedscenarios",
                            value: !suite.synchedscenarios,
                          }),
                        );
                        updateSync(suite.idtest_suite, !suite.synchedscenarios);
                      }}
                    />
                  }
                  label="Synchronized Tests"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.benchmarkscenarios ? true : false}
                      onChange={() => {
                        dispatch(
                          updateSuiteField({
                            field: "benchmarkscenarios",
                            value: !suite.benchmarkscenarios,
                          }),
                        );
                        updateBM(suite.idtest_suite, !suite.benchmarkscenarios);
                      }}
                    />
                  }
                  label="Benchmark Tests"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.headless ? true : false}
                      onChange={() => {
                        dispatch(
                          updateSuiteField({
                            field: "headless",
                            value: !suite.headless,
                          }),
                        );
                        udpateHeadless(suite.idtest_suite, !suite.headless);
                      }}
                    />
                  }
                  label="Headless Execution"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.ssonerror}
                      onChange={() => {
                        dispatch(
                          updateSuiteField({
                            field: "ssonerror",
                            value: !suite.ssonerror,
                          }),
                        );
                        updateScreenShot(suite.idtest_suite, !suite.ssonerror);
                      }}
                    />
                  }
                  label="Capture screenshots only on test failure"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.indEmail}
                      onChange={() => {
                        dispatch(
                          updateSuiteField({
                            field: "indEmail",
                            value: !suite.indEmail,
                          }),
                        );
                        updateResultEmail(suite.idtest_suite, !suite.indEmail);
                      }}
                    />
                  }
                  label="Email individual test result"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={!!suite.emailOnSuiteFailureOnly}
                      disabled={updateEmailOnSuiteFailureOnly.isPending}
                      onChange={handleEmailOnSuiteFailureOnlyToggle}
                    />
                  }
                  label="Send email only on suite failure"
                />
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={suite.isVideoEnabled === 1}
                      onChange={() => {
                        const newValue = suite.isVideoEnabled === 1 ? 0 : 1;
                        dispatch(
                          updateSuiteField({
                            field: "isVideoEnabled",
                            value: newValue,
                          }),
                        );
                        updateTestSuiteIsVideoEnabled(suite.idtest_suite, newValue);
                      }}
                    />
                  }
                  label="Enable Video Recording"
                />
                {/* <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={imageCompare}
                      onChange={() => setImageCompare(!imageCompare)}
                    />
                  }
                  label="Image Compare"
                /> */}

                {suite?.suite_Type === "mobile" && (
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={suite.supports_on_all_device_execution === 1}
                        onChange={() => {
                          const newValue = suite.supports_on_all_device_execution === 1 ? 0 : 1;
                          dispatch(
                            updateSuiteField({
                              field: "supports_on_all_device_execution",
                              value: newValue,
                            }),
                          );
                          updateRunOnAllDevices(suite.idtest_suite, newValue);
                        }}
                      />
                    }
                    label="Run Test Cases on all connected Devices"
                  />
                )}
              </FormGroup>
            </Box>
          </Box>
          <Box>
            {suite?.suite_Type !== "mobile" && (
              <CustomInput
                labelinput="Proxy Url"
                placeholder={"Enter proxy Url"}
                value={proxyUrl}
                onChange={(e) => setProxyUrl(e.target.value)}
              />
            )}
            <Box display="flex" pt={2} columnGap={2}>
              <CustomInput
                labelinput="Iterations"
                placeholder={"Enter iterations"}
                value={iterations}
                onChange={(e) => setIterations(e.target.value)}
              />
              <CustomInput
                labelinput="Email to receive reports "
                placeholder={"Enter email"}
                value={suite?.resultsemail}
                onChange={(event) => {
                  dispatch(updateSuiteField({ field: "resultsemail", value: event.target.value }));
                  debouncedUpdateEmail(event.target.value);
                }}
                flex={1}
              />
            </Box>
          </Box>
        </>
      ),
    },
    {
      icon: <></>,
      label: "Integration",
      content: <IntegrationTab ref={integrationRef} suite={suite} licenceKey={data} />,
    },
    {
      icon: <></>,
      label: "Variables",
      content: (
        <Box py={2}>
          <Box mb={2}>
            <StyledLabel>Test Variables (Key-Value Pairs)</StyledLabel>

            {variables.map((variable, index) => (
              <VariableRow key={index}>
                <CustomInput
                  placeholder="Key"
                  value={variable.key}
                  onChange={(e) => handleVariableChange(index, "key", e.target.value)}
                  sx={{ flex: 1 }}
                />
                <CustomInput
                  placeholder="Value"
                  value={variable.value}
                  onChange={(e) => handleVariableChange(index, "value", e.target.value)}
                  sx={{ flex: 1 }}
                />
                <IconButton
                  onClick={() => removeVariableRow(index)}
                  color="error"
                  size="small"
                  sx={{ cursor: "pointer" }}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              </VariableRow>
            ))}

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Button
                startIcon={<AddCircleOutlineIcon />}
                onClick={addVariableRow}
                sx={{ cursor: "pointer" }}
                variant="outlined"
                color="primary"
              >
                Add Variable
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveVariables}
                disabled={!isSaveEnabled}
                sx={{
                  backgroundColor: "#ff5336",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#ff5336",
                    opacity: 0.9,
                  },
                }}
              >
                Save Variables
              </Button>
            </Box>

            <StyledLabel sx={{ mt: 2 }}>JSON Editor</StyledLabel>
            {jsonError && (
              <Box
                sx={{
                  p: 2,
                  bgcolor: "#fdeded",
                  color: "#d32f2f",
                  borderRadius: "8px",
                  mb: 2,
                  border: "1px solid #ef9a9a",
                }}
              >
                {jsonErrorMessage}
              </Box>
            )}
            <TextField
              multiline
              fullWidth
              rows={6}
              value={jsonPreview}
              onChange={handleJsonPreviewChange}
              error={jsonError}
              variant="outlined"
              InputProps={{
                sx: {
                  fontFamily: "monospace",
                  fontSize: "14px",
                  borderRadius: "8px",
                },
              }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
              Edit JSON directly or use the key-value inputs above. Example:{" "}
              {'{ "username": "test", "password": "pass123" }'}
            </Typography>
          </Box>
        </Box>
      ),
    },
    {
      icon: <></>,
      label: "Scheduler",
      content: (
        <Box py={2}>
          <Box mb={2}>
            <Scheduler suiteId={suite.idtest_suite} />
          </Box>
        </Box>
      ),
    },
  ];

  return (
    <>
      <CustomDialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenSuiteSettings(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            width: "900px",
            maxWidth: "900px",
          },
        }}
      >
        <PageTitle title="Settings" variant="h5" />
        <DialogContent sx={{ width: "100%", px: 0 }}>
          <TabComponent tabs={tabs} />
        </DialogContent>
        <DialogActions sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <StyledButton
            sx={{ color: "#ff5336" }}
            variant="text"
            color="warning"
            onClick={() => setOpenSuiteSettings(false)}
          >
            Cancel
          </StyledButton>
          <StyledButton
            variant="text"
            color="warning"
            sx={{
              backgroundColor: "#ff5336",
              color: "#ffffff",
              boxShadow: "0px 16px 30.6px 0px rgba(255, 83, 54, 0.27)",
            }}
            onClick={() => {
              handleRun();
            }}
          >
            Run
          </StyledButton>
        </DialogActions>
      </CustomDialog>
    </>
  );
}
